module.exports = __webpack_public_path__ + "img/Purple_Space_Invader.b7bbce6d.gif";